import React from 'react'
import {DetailsPageRuntimeContext} from '../components/runtime-context/context'
import {State} from '../types'

export function usePageStateSelector<T>(selector: (state: State) => T): T {
  return selector(React.useContext(DetailsPageRuntimeContext).state)
}

export const usePageActions = () => React.useContext(DetailsPageRuntimeContext).actions
